import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Title,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Title, Legend);

const LicenseCard = ({ licenseData }) => {
  // Extract values from props (with fallbacks)
  const taken = licenseData?.taken || 0;
  const applied = licenseData?.applied || 0;
  const pending = licenseData?.remaining || Math.max(taken - applied, 0);
  const total = taken;
  // Chart data
  const data = {
    labels: [""], // Single horizontal bar
    datasets: [
      {
        label: "Applied",
        data: [applied],
        backgroundColor: "#FF6B00",
        borderWidth: 0,
        barThickness: 30,
      },
      {
        label: "Pending",
        data: [pending],
        backgroundColor: "#FF9F43",
        borderWidth: 0,
        barThickness: 30,
      },
      {
        label: "Taken",
        data: [total],
        backgroundColor: "#FFB877",
        borderWidth: 0,
        barThickness: 30,
      },
    ],
  };

  // Chart options
  const options = {
    indexAxis: "y", // Horizontal bar
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          font: {
            family: "Nunito Sans, sans-serif",
            size: 12,
          },
          color: "#595C60",
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || "";
            const value = context.raw || 0;
            return `${label}: ${value}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          font: { family: "Nunito Sans, sans-serif", size: 12 },
          color: "#595C60",
        },
        grid: { display: false },
      },
      y: {
        stacked: true,
        ticks: {
          font: { family: "Nunito Sans, sans-serif", size: 12 },
          color: "#595C60",
        },
        grid: { display: false },
      },
    },
    elements: {
      bar: {
        borderRadius: 5,
      },
    },
  };

  return (
    <div className="bg-white rounded-xl p-4 w-full h-full flex flex-col shadow-md hover:shadow-lg transition-all duration-300">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <h2
          style={{
            fontFamily: "Nunito Sans, sans-serif",
            fontSize: "20px",
            fontWeight: "bold",
            color: "#202224",
          }}
        >
          Deletions Overview
        </h2>
        <p
          className="text-base font-semibold"
          style={{
            color: "#595C60",
            fontFamily: "Nunito Sans, sans-serif",
          }}
        >
          Total: {total}
        </p>
      </div>

      {/* Chart */}
      <div className="w-full h-28">
        <Bar data={data} options={options} />
      </div>

      {/* Summary List */}
      <div className="mt-4 text-sm space-y-1">
        <p>
          <span className="font-semibold" style={{ color: "#FF6B00" }}>
            Applied:
          </span>{" "}
          {applied}
        </p>
        <p>
          <span className="font-semibold" style={{ color: "#FF9F43" }}>
            Pending:
          </span>{" "}
          {pending}
        </p>
        <p>
          <span className="font-semibold" style={{ color: "#FFB877" }}>
            Taken:
          </span>{" "}
          {taken}
        </p>
      </div>
    </div>
  );
};

export default LicenseCard;
